// 
// 用户权限配置
// 
// 
<template>
  <div class="mySelect">
    <div class="isAdmin">
      <span class="font_small mr-5">是否是系统管理员:</span>
      <el-radio-group v-model="roleisadmin">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="2">否</el-radio>
      </el-radio-group>
    </div>
    <div class="oneTab selectType" v-show="roleisadmin==2">
      <muserTypeSelectNew @onDataChanged="onSelectDataChanged" ref="muserTypeSelectNew"></muserTypeSelectNew>
    </div>
    <div class="mt-2" v-if="saveIsShow">
      <el-button style="margin-top: 12px;" type="primary" @click="save">更新</el-button>
    </div>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { muserRoleInitApi, muserEditRoleApi } from "@/api/module/muser/muser";
import { muserTypeSelectNew } from "@/views/module/muser/component/index";

export default {
  name: "MuserRoleConfigBox",
  
  mixins: [BaseVue],
  
  components: {
    muserTypeSelectNew,
  },
  
  data() {
    return {
      saveIsShow: true,
      muid: "",
      roleisadmin: 1,
      rid: "",
      unitid: "",
      partyorgid: "",
      data: null
    };
  },
  
  methods: {
    // 初始化
    init() {
      muserRoleInitApi(this.muid)
        .then((r) => {
          this.data = r;
          
          if (r.isadmin) {
            this.roleisadmin = 1;
          } else {
            this.roleisadmin = 2;
          }
          
        })
    },
    
    initData(e) {
      this.saveIsShow = e;
    },
    
    initMUid(muid) {
      this.muid = muid;
    },
    
    // 更新
    save() {
      let isad = this.roleisadmin == 1;
      
      muserEditRoleApi(this.muid, this.rid, isad, this.unitid, this.partyorgid)
        .then((r) => {
          this.$message({
            message: "绑定成功",
            type: "success",
          });
          this.init();
        })
        
    },
    
    // emit
    setPowerInfo(e) {
      e.isadmin = this.roleisadmin;
      this.$emit("powerChange", e);
    },
    
    // components
    onSelectDataChanged(data) {
      if (!this.saveIsShow) {
        this.setPowerInfo(data);
      }
      this.rid = data.role;
      let roleList = data.rid;
      if (roleList) {
        let relid = roleList[roleList.length - 1];
        // 党组织
        if (data.role == "00002") {
          this.partyorgid = relid;
        }
        
        // 单位
        if (data.role == "00003") {
          this.unitid = relid;
        }
      }
    }
  },
  
  watch: {
    roleisadmin(newVal) {
      let val = newVal == 1 ? 1 : 0;
      this.$emit("onChangedIsAdmin", val);
      
      if (newVal == 2) {
        this.$nextTick(() => {
          this.$refs.muserTypeSelectNew.init(this.data);
        });
      }
    }
  },
  
  mounted() {
    // this.init();
  }
};
</script>

<style scoped lang="scss">
.mySelect {
  .isAdmin {
    line-height: 40px;
    .font_small {
      width: 110px;
      display: inline-block;
    }
  }
  .selectType {
    margin-top: 20px;
  }
  .title {
    margin-right: 30px;
  }
}
</style>